const PERCENT_MULTIPLIER = 100;

export function formatFloatAsPercent(value: number): string {
	return `${Math.ceil(value * PERCENT_MULTIPLIER)}%`;
}
